import {ChangeDetectionStrategy, Component, input, TemplateRef} from '@angular/core';
import {NgClass, NgTemplateOutlet} from "@angular/common";

@Component({
  selector: 'homey-page-title-layout',
  imports: [
    NgClass,
    NgTemplateOutlet
  ],
  templateUrl: './page-title-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageTitleLayoutComponent {
  public readonly centered = input(false);
  public readonly atPageTop = input<boolean>(true);
  public readonly subtitle = input<string>();
  public readonly subtitleTemplate = input<TemplateRef<unknown>>();
}
